module.exports = __webpack_public_path__ + "gd.03bd9ec8.svg";